import classNames from 'classnames';
import styles from './NavigationLeft.module.scss';
import { Link } from 'ui/components';
import { useEffect, useState } from 'react';
import { ReactComponent as ChevronIcon } from 'ui/icons/icon-chevron-left.svg';

export interface NavigationLeftProps {
	className?: string;
	headingNavItem?: Navigation.NavigationItem;
	parentNavItem?: Navigation.NavigationItem;
	currentNavItem?: Navigation.NavigationItem;
}

export const NavigationLeft: React.FC<NavigationLeftProps> = ({ className, headingNavItem, currentNavItem, parentNavItem }) => (
	<nav aria-label="Undermenu" className={classNames(styles.NavigationLeft, className)}>
		{headingNavItem && (
			<Link
                ariaLabel={headingNavItem.name}
                url={headingNavItem.url}
				className={classNames(styles.NavigationItem_link, {[styles.NavigationItem_link___isHeadline]: true})}>
                    {headingNavItem.name}
            </Link>
		)}
		<NavigationItem heading={headingNavItem} parentNavItem={parentNavItem} currentNavItem={currentNavItem} />
	</nav>
);
const isActiveItem = (item: Navigation.NavigationItem, item2: Navigation.NavigationItem) => {
	return item.name === item2.name;
};
const NavigationItem = ({heading, currentNavItem, parentNavItem }) => {
    const [headingItem, setHeadingItem] = useState<Navigation.NavigationItem>({});
    const [parentItem, setParentItem] = useState<Navigation.NavigationItem>({});
    const [activeNavItem, setActiveNavItem] = useState<Navigation.NavigationItem>({});
  
    useEffect(() => {
        if (!parentNavItem.name) {
            setParentItem(currentNavItem);
        } else {
            setParentItem(parentNavItem);
        }
		setActiveNavItem(parentNavItem); // automatically unfolds the chrevron when rendering window
        setHeadingItem(heading);
    }, [parentNavItem, currentNavItem, heading]);

    const isParentSibling = (item: Navigation.NavigationItem) => {
        return parentNavItem && headingItem.descendants?.some(desc => desc.name === item.name && desc.name !== parentNavItem.name);
    };

    const shouldShowChevron = (item: Navigation.NavigationItem) => {
        var currentSibling = parentNavItem.descendants?.some(desc => desc.name === item.name) && item.name !== currentNavItem.name;
        return (isParentSibling(item) || item.name === parentNavItem.name) && !isActiveItem(item, currentNavItem)  && !currentSibling;
    };
  
    return (
        <>
            {headingItem.descendants?.length != 0 && (
                <ul>
                    {headingItem.descendants &&
                        headingItem.descendants.map((item: Navigation.NavigationItem, index: number) => {
                            return (
                                item?.hidden !== true && (
                                    <li
                                        key={index}
                                        className={classNames(styles.NavigationItem_item, {
                                            [styles.NavigationItem_item___isOpen]: isActiveItem(item, currentNavItem),
                                            ['']: !isActiveItem(item, activeNavItem),
                                        })}
                                    >
                                        <div
                                            className={classNames(styles.NavigationItem_dropdown, {
                                                [styles.NavigationItem_dropdown___isActive]: item.active === true,
                                                ['']: item.active === false,
                                            })}
                                        >
                                            <div className={styles.NavigationItem_buttonIconContainer}>
                                                {item.descendants &&
                                                    item.descendants?.length !== 0 &&
                                                    item.descendants?.find((child) => child.hidden === false) &&
                                                    shouldShowChevron(item) && (
                                                        <div
                                                            className={styles.NavigationItem_buttonIconContainerInner}
                                                            onClick={() => {
                                                                setActiveNavItem(!isActiveItem(item, activeNavItem) ? item : {});
                                                            }}
                                                        >
                                                            {isActiveItem(item, activeNavItem) ? (
                                                                <ChevronIcon
                                                                    className={classNames(
                                                                        styles.NavigationItem_buttonIcon,
                                                                        styles.NavigationItem_buttonIcon___isActive,
                                                                    )}
                                                                />
                                                            ) : (
                                                                <ChevronIcon className={classNames(styles.NavigationItem_buttonIcon)} />
                                                            )}
                                                        </div>
                                                    )}
                                            </div>
  
                                            <Link
                                                ariaLabel={item.name}
                                                url={item.url}
                                                className={classNames(styles.NavigationItem_link, {
                                                    [styles.NavigationItem_link___isActive]: isActiveItem(item, currentNavItem),
                                                    [styles.NavigationItem_link___isCurrent]: item.current === true,
                                                })}
                                            >
                                                {item.name}
                                            </Link>
                                        </div>
  
                                        {isActiveItem(item, activeNavItem) && 
                                         item?.descendants && 
                                         shouldShowChevron(item) && (
                                            <NavigationItem heading={item} parentNavItem={item} currentNavItem={currentNavItem} />
                                        )}
                                    </li>
                                )
                            );
                        })}
                </ul>
            )}
        </>
    );
};